import * as React from 'react'
import { PosListingModels } from '@getgreenline/inventory'
import { THEME_COLORS } from '@getgreenline/shared'
import { CategoriesModels } from '@getgreenline/categories'

interface Props {
  category?: CategoriesModels.IBaseCategory
  customCategoryName?: string
}

export const CategorySelectOption = (props: Props) => {
  const isChildCategory = props.category?.parentCategoryId
  const squareStyle: React.CSSProperties = isChildCategory
    ? { width: 12, height: 12, marginLeft: 16 }
    : { width: 16, height: 16 }

  return (
    <div style={{ display: 'flex', padding: 8, alignItems: 'center' }}>
      <div
        style={{
          ...squareStyle,
          backgroundColor: props.category?.colorHex || THEME_COLORS.MONO.monodd,
          marginRight: 8,
        }}
      />
      {props.customCategoryName ? (
        <div>{props.customCategoryName}</div>
      ) : (
        <div>{props.category?.name || PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME}</div>
      )}
    </div>
  )
}
